/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RedirectRouteImport } from './routes/redirect'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProtectedRedirectToCustomerPortalRouteImport } from './routes/_protected/redirect-to-customer-portal'
import { Route as ProtectedPurchaseRouteImport } from './routes/_protected/purchase'
import { Route as ProtectedDashboardRouteImport } from './routes/_protected/dashboard'
import { Route as ProtectedTaxRouteImport } from './routes/_protected/_tax'
import { Route as ProtectedLeasingRouteImport } from './routes/_protected/_leasing'
import { Route as ProtectedInsightsRouteImport } from './routes/_protected/_insights'
import { Route as ProtectedImportRouteImport } from './routes/_protected/_import'
import { Route as ProtectedEquipmentRouteImport } from './routes/_protected/_equipment'
import { Route as ProtectedDealershipRouteImport } from './routes/_protected/_dealership'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthSignUpIndexRouteImport } from './routes/_auth/sign-up.index'
import { Route as AuthForgotPasswordIndexRouteImport } from './routes/_auth/forgot-password.index'
import { Route as ProtectedInsightsInsightsRouteImport } from './routes/_protected/_insights/insights'
import { Route as AuthSignUpTokenRouteImport } from './routes/_auth/sign-up.$token'
import { Route as AuthForgotPasswordTokenRouteImport } from './routes/_auth/forgot-password.$token'
import { Route as ProtectedTaxTaxIndexRouteImport } from './routes/_protected/_tax/tax.index'
import { Route as ProtectedLeasingLeasingIndexRouteImport } from './routes/_protected/_leasing/leasing.index'
import { Route as ProtectedImportImportIndexRouteImport } from './routes/_protected/_import/import.index'
import { Route as ProtectedEquipmentEquipmentIndexRouteImport } from './routes/_protected/_equipment/equipment.index'
import { Route as ProtectedDealershipDealershipIndexRouteImport } from './routes/_protected/_dealership/dealership.index'
import { Route as ProtectedTaxTaxCreateRouteImport } from './routes/_protected/_tax/tax.create'
import { Route as ProtectedLeasingLeasingCreateRouteImport } from './routes/_protected/_leasing/leasing.create'
import { Route as ProtectedLeasingLeasingIdRouteImport } from './routes/_protected/_leasing/leasing.$id'
import { Route as ProtectedImportImportCreateRouteImport } from './routes/_protected/_import/import.create'
import { Route as ProtectedImportImportIdRouteImport } from './routes/_protected/_import/import.$id'
import { Route as ProtectedDealershipDealershipUsersRouteImport } from './routes/_protected/_dealership/dealership.users'
import { Route as ProtectedDealershipDealershipSubscriptionRouteImport } from './routes/_protected/_dealership/dealership.subscription'
import { Route as ProtectedDealershipDealershipProfileRouteImport } from './routes/_protected/_dealership/dealership.profile'
import { Route as ProtectedDealershipDealershipPaymentMethodsRouteImport } from './routes/_protected/_dealership/dealership.payment-methods'
import { Route as ProtectedDealershipDealershipPaymentHistoryRouteImport } from './routes/_protected/_dealership/dealership.payment-history'
import { Route as ProtectedDealershipDealershipNotificationsRouteImport } from './routes/_protected/_dealership/dealership.notifications'
import { Route as ProtectedTaxTaxIdIndexRouteImport } from './routes/_protected/_tax/tax.$id.index'

const RedirectRoute = RedirectRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRedirectToCustomerPortalRoute =
  ProtectedRedirectToCustomerPortalRouteImport.update({
    id: '/redirect-to-customer-portal',
    path: '/redirect-to-customer-portal',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedPurchaseRoute = ProtectedPurchaseRouteImport.update({
  id: '/purchase',
  path: '/purchase',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedTaxRoute = ProtectedTaxRouteImport.update({
  id: '/_tax',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedLeasingRoute = ProtectedLeasingRouteImport.update({
  id: '/_leasing',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedInsightsRoute = ProtectedInsightsRouteImport.update({
  id: '/_insights',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedImportRoute = ProtectedImportRouteImport.update({
  id: '/_import',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedEquipmentRoute = ProtectedEquipmentRouteImport.update({
  id: '/_equipment',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDealershipRoute = ProtectedDealershipRouteImport.update({
  id: '/_dealership',
  getParentRoute: () => ProtectedRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSignUpIndexRoute = AuthSignUpIndexRouteImport.update({
  id: '/sign-up/',
  path: '/sign-up/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordIndexRoute = AuthForgotPasswordIndexRouteImport.update({
  id: '/forgot-password/',
  path: '/forgot-password/',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedInsightsInsightsRoute =
  ProtectedInsightsInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => ProtectedInsightsRoute,
  } as any)
const AuthSignUpTokenRoute = AuthSignUpTokenRouteImport.update({
  id: '/sign-up/$token',
  path: '/sign-up/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordTokenRoute = AuthForgotPasswordTokenRouteImport.update({
  id: '/forgot-password/$token',
  path: '/forgot-password/$token',
  getParentRoute: () => AuthRoute,
} as any)
const ProtectedTaxTaxIndexRoute = ProtectedTaxTaxIndexRouteImport.update({
  id: '/tax/',
  path: '/tax/',
  getParentRoute: () => ProtectedTaxRoute,
} as any)
const ProtectedLeasingLeasingIndexRoute =
  ProtectedLeasingLeasingIndexRouteImport.update({
    id: '/leasing/',
    path: '/leasing/',
    getParentRoute: () => ProtectedLeasingRoute,
  } as any)
const ProtectedImportImportIndexRoute =
  ProtectedImportImportIndexRouteImport.update({
    id: '/import/',
    path: '/import/',
    getParentRoute: () => ProtectedImportRoute,
  } as any)
const ProtectedEquipmentEquipmentIndexRoute =
  ProtectedEquipmentEquipmentIndexRouteImport.update({
    id: '/equipment/',
    path: '/equipment/',
    getParentRoute: () => ProtectedEquipmentRoute,
  } as any)
const ProtectedDealershipDealershipIndexRoute =
  ProtectedDealershipDealershipIndexRouteImport.update({
    id: '/dealership/',
    path: '/dealership/',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedTaxTaxCreateRoute = ProtectedTaxTaxCreateRouteImport.update({
  id: '/tax/create',
  path: '/tax/create',
  getParentRoute: () => ProtectedTaxRoute,
} as any)
const ProtectedLeasingLeasingCreateRoute =
  ProtectedLeasingLeasingCreateRouteImport.update({
    id: '/leasing/create',
    path: '/leasing/create',
    getParentRoute: () => ProtectedLeasingRoute,
  } as any)
const ProtectedLeasingLeasingIdRoute =
  ProtectedLeasingLeasingIdRouteImport.update({
    id: '/leasing/$id',
    path: '/leasing/$id',
    getParentRoute: () => ProtectedLeasingRoute,
  } as any)
const ProtectedImportImportCreateRoute =
  ProtectedImportImportCreateRouteImport.update({
    id: '/import/create',
    path: '/import/create',
    getParentRoute: () => ProtectedImportRoute,
  } as any)
const ProtectedImportImportIdRoute = ProtectedImportImportIdRouteImport.update({
  id: '/import/$id',
  path: '/import/$id',
  getParentRoute: () => ProtectedImportRoute,
} as any)
const ProtectedDealershipDealershipUsersRoute =
  ProtectedDealershipDealershipUsersRouteImport.update({
    id: '/dealership/users',
    path: '/dealership/users',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedDealershipDealershipSubscriptionRoute =
  ProtectedDealershipDealershipSubscriptionRouteImport.update({
    id: '/dealership/subscription',
    path: '/dealership/subscription',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedDealershipDealershipProfileRoute =
  ProtectedDealershipDealershipProfileRouteImport.update({
    id: '/dealership/profile',
    path: '/dealership/profile',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedDealershipDealershipPaymentMethodsRoute =
  ProtectedDealershipDealershipPaymentMethodsRouteImport.update({
    id: '/dealership/payment-methods',
    path: '/dealership/payment-methods',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedDealershipDealershipPaymentHistoryRoute =
  ProtectedDealershipDealershipPaymentHistoryRouteImport.update({
    id: '/dealership/payment-history',
    path: '/dealership/payment-history',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedDealershipDealershipNotificationsRoute =
  ProtectedDealershipDealershipNotificationsRouteImport.update({
    id: '/dealership/notifications',
    path: '/dealership/notifications',
    getParentRoute: () => ProtectedDealershipRoute,
  } as any)
const ProtectedTaxTaxIdIndexRoute = ProtectedTaxTaxIdIndexRouteImport.update({
  id: '/tax/$id/',
  path: '/tax/$id/',
  getParentRoute: () => ProtectedTaxRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/redirect': typeof RedirectRoute
  '/login': typeof AuthLoginRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/purchase': typeof ProtectedPurchaseRoute
  '/redirect-to-customer-portal': typeof ProtectedRedirectToCustomerPortalRoute
  '/forgot-password/$token': typeof AuthForgotPasswordTokenRoute
  '/sign-up/$token': typeof AuthSignUpTokenRoute
  '/insights': typeof ProtectedInsightsInsightsRoute
  '/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/sign-up/': typeof AuthSignUpIndexRoute
  '/dealership/notifications': typeof ProtectedDealershipDealershipNotificationsRoute
  '/dealership/payment-history': typeof ProtectedDealershipDealershipPaymentHistoryRoute
  '/dealership/payment-methods': typeof ProtectedDealershipDealershipPaymentMethodsRoute
  '/dealership/profile': typeof ProtectedDealershipDealershipProfileRoute
  '/dealership/subscription': typeof ProtectedDealershipDealershipSubscriptionRoute
  '/dealership/users': typeof ProtectedDealershipDealershipUsersRoute
  '/import/$id': typeof ProtectedImportImportIdRoute
  '/import/create': typeof ProtectedImportImportCreateRoute
  '/leasing/$id': typeof ProtectedLeasingLeasingIdRoute
  '/leasing/create': typeof ProtectedLeasingLeasingCreateRoute
  '/tax/create': typeof ProtectedTaxTaxCreateRoute
  '/dealership/': typeof ProtectedDealershipDealershipIndexRoute
  '/equipment/': typeof ProtectedEquipmentEquipmentIndexRoute
  '/import/': typeof ProtectedImportImportIndexRoute
  '/leasing/': typeof ProtectedLeasingLeasingIndexRoute
  '/tax/': typeof ProtectedTaxTaxIndexRoute
  '/tax/$id/': typeof ProtectedTaxTaxIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/redirect': typeof RedirectRoute
  '/login': typeof AuthLoginRoute
  '/dashboard': typeof ProtectedDashboardRoute
  '/purchase': typeof ProtectedPurchaseRoute
  '/redirect-to-customer-portal': typeof ProtectedRedirectToCustomerPortalRoute
  '/forgot-password/$token': typeof AuthForgotPasswordTokenRoute
  '/sign-up/$token': typeof AuthSignUpTokenRoute
  '/insights': typeof ProtectedInsightsInsightsRoute
  '/forgot-password': typeof AuthForgotPasswordIndexRoute
  '/sign-up': typeof AuthSignUpIndexRoute
  '/dealership/notifications': typeof ProtectedDealershipDealershipNotificationsRoute
  '/dealership/payment-history': typeof ProtectedDealershipDealershipPaymentHistoryRoute
  '/dealership/payment-methods': typeof ProtectedDealershipDealershipPaymentMethodsRoute
  '/dealership/profile': typeof ProtectedDealershipDealershipProfileRoute
  '/dealership/subscription': typeof ProtectedDealershipDealershipSubscriptionRoute
  '/dealership/users': typeof ProtectedDealershipDealershipUsersRoute
  '/import/$id': typeof ProtectedImportImportIdRoute
  '/import/create': typeof ProtectedImportImportCreateRoute
  '/leasing/$id': typeof ProtectedLeasingLeasingIdRoute
  '/leasing/create': typeof ProtectedLeasingLeasingCreateRoute
  '/tax/create': typeof ProtectedTaxTaxCreateRoute
  '/dealership': typeof ProtectedDealershipDealershipIndexRoute
  '/equipment': typeof ProtectedEquipmentEquipmentIndexRoute
  '/import': typeof ProtectedImportImportIndexRoute
  '/leasing': typeof ProtectedLeasingLeasingIndexRoute
  '/tax': typeof ProtectedTaxTaxIndexRoute
  '/tax/$id': typeof ProtectedTaxTaxIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/_protected': typeof ProtectedRouteWithChildren
  '/redirect': typeof RedirectRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_protected/_dealership': typeof ProtectedDealershipRouteWithChildren
  '/_protected/_equipment': typeof ProtectedEquipmentRouteWithChildren
  '/_protected/_import': typeof ProtectedImportRouteWithChildren
  '/_protected/_insights': typeof ProtectedInsightsRouteWithChildren
  '/_protected/_leasing': typeof ProtectedLeasingRouteWithChildren
  '/_protected/_tax': typeof ProtectedTaxRouteWithChildren
  '/_protected/dashboard': typeof ProtectedDashboardRoute
  '/_protected/purchase': typeof ProtectedPurchaseRoute
  '/_protected/redirect-to-customer-portal': typeof ProtectedRedirectToCustomerPortalRoute
  '/_auth/forgot-password/$token': typeof AuthForgotPasswordTokenRoute
  '/_auth/sign-up/$token': typeof AuthSignUpTokenRoute
  '/_protected/_insights/insights': typeof ProtectedInsightsInsightsRoute
  '/_auth/forgot-password/': typeof AuthForgotPasswordIndexRoute
  '/_auth/sign-up/': typeof AuthSignUpIndexRoute
  '/_protected/_dealership/dealership/notifications': typeof ProtectedDealershipDealershipNotificationsRoute
  '/_protected/_dealership/dealership/payment-history': typeof ProtectedDealershipDealershipPaymentHistoryRoute
  '/_protected/_dealership/dealership/payment-methods': typeof ProtectedDealershipDealershipPaymentMethodsRoute
  '/_protected/_dealership/dealership/profile': typeof ProtectedDealershipDealershipProfileRoute
  '/_protected/_dealership/dealership/subscription': typeof ProtectedDealershipDealershipSubscriptionRoute
  '/_protected/_dealership/dealership/users': typeof ProtectedDealershipDealershipUsersRoute
  '/_protected/_import/import/$id': typeof ProtectedImportImportIdRoute
  '/_protected/_import/import/create': typeof ProtectedImportImportCreateRoute
  '/_protected/_leasing/leasing/$id': typeof ProtectedLeasingLeasingIdRoute
  '/_protected/_leasing/leasing/create': typeof ProtectedLeasingLeasingCreateRoute
  '/_protected/_tax/tax/create': typeof ProtectedTaxTaxCreateRoute
  '/_protected/_dealership/dealership/': typeof ProtectedDealershipDealershipIndexRoute
  '/_protected/_equipment/equipment/': typeof ProtectedEquipmentEquipmentIndexRoute
  '/_protected/_import/import/': typeof ProtectedImportImportIndexRoute
  '/_protected/_leasing/leasing/': typeof ProtectedLeasingLeasingIndexRoute
  '/_protected/_tax/tax/': typeof ProtectedTaxTaxIndexRoute
  '/_protected/_tax/tax/$id/': typeof ProtectedTaxTaxIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/redirect'
    | '/login'
    | '/dashboard'
    | '/purchase'
    | '/redirect-to-customer-portal'
    | '/forgot-password/$token'
    | '/sign-up/$token'
    | '/insights'
    | '/forgot-password/'
    | '/sign-up/'
    | '/dealership/notifications'
    | '/dealership/payment-history'
    | '/dealership/payment-methods'
    | '/dealership/profile'
    | '/dealership/subscription'
    | '/dealership/users'
    | '/import/$id'
    | '/import/create'
    | '/leasing/$id'
    | '/leasing/create'
    | '/tax/create'
    | '/dealership/'
    | '/equipment/'
    | '/import/'
    | '/leasing/'
    | '/tax/'
    | '/tax/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/redirect'
    | '/login'
    | '/dashboard'
    | '/purchase'
    | '/redirect-to-customer-portal'
    | '/forgot-password/$token'
    | '/sign-up/$token'
    | '/insights'
    | '/forgot-password'
    | '/sign-up'
    | '/dealership/notifications'
    | '/dealership/payment-history'
    | '/dealership/payment-methods'
    | '/dealership/profile'
    | '/dealership/subscription'
    | '/dealership/users'
    | '/import/$id'
    | '/import/create'
    | '/leasing/$id'
    | '/leasing/create'
    | '/tax/create'
    | '/dealership'
    | '/equipment'
    | '/import'
    | '/leasing'
    | '/tax'
    | '/tax/$id'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/_protected'
    | '/redirect'
    | '/_auth/login'
    | '/_protected/_dealership'
    | '/_protected/_equipment'
    | '/_protected/_import'
    | '/_protected/_insights'
    | '/_protected/_leasing'
    | '/_protected/_tax'
    | '/_protected/dashboard'
    | '/_protected/purchase'
    | '/_protected/redirect-to-customer-portal'
    | '/_auth/forgot-password/$token'
    | '/_auth/sign-up/$token'
    | '/_protected/_insights/insights'
    | '/_auth/forgot-password/'
    | '/_auth/sign-up/'
    | '/_protected/_dealership/dealership/notifications'
    | '/_protected/_dealership/dealership/payment-history'
    | '/_protected/_dealership/dealership/payment-methods'
    | '/_protected/_dealership/dealership/profile'
    | '/_protected/_dealership/dealership/subscription'
    | '/_protected/_dealership/dealership/users'
    | '/_protected/_import/import/$id'
    | '/_protected/_import/import/create'
    | '/_protected/_leasing/leasing/$id'
    | '/_protected/_leasing/leasing/create'
    | '/_protected/_tax/tax/create'
    | '/_protected/_dealership/dealership/'
    | '/_protected/_equipment/equipment/'
    | '/_protected/_import/import/'
    | '/_protected/_leasing/leasing/'
    | '/_protected/_tax/tax/'
    | '/_protected/_tax/tax/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  ProtectedRoute: typeof ProtectedRouteWithChildren
  RedirectRoute: typeof RedirectRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/redirect': {
      id: '/redirect'
      path: '/redirect'
      fullPath: '/redirect'
      preLoaderRoute: typeof RedirectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected/redirect-to-customer-portal': {
      id: '/_protected/redirect-to-customer-portal'
      path: '/redirect-to-customer-portal'
      fullPath: '/redirect-to-customer-portal'
      preLoaderRoute: typeof ProtectedRedirectToCustomerPortalRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/purchase': {
      id: '/_protected/purchase'
      path: '/purchase'
      fullPath: '/purchase'
      preLoaderRoute: typeof ProtectedPurchaseRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/dashboard': {
      id: '/_protected/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_tax': {
      id: '/_protected/_tax'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedTaxRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_leasing': {
      id: '/_protected/_leasing'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedLeasingRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_insights': {
      id: '/_protected/_insights'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedInsightsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_import': {
      id: '/_protected/_import'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedImportRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_equipment': {
      id: '/_protected/_equipment'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedEquipmentRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/_dealership': {
      id: '/_protected/_dealership'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ProtectedDealershipRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/sign-up/': {
      id: '/_auth/sign-up/'
      path: '/sign-up'
      fullPath: '/sign-up/'
      preLoaderRoute: typeof AuthSignUpIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password/': {
      id: '/_auth/forgot-password/'
      path: '/forgot-password'
      fullPath: '/forgot-password/'
      preLoaderRoute: typeof AuthForgotPasswordIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/_insights/insights': {
      id: '/_protected/_insights/insights'
      path: '/insights'
      fullPath: '/insights'
      preLoaderRoute: typeof ProtectedInsightsInsightsRouteImport
      parentRoute: typeof ProtectedInsightsRoute
    }
    '/_auth/sign-up/$token': {
      id: '/_auth/sign-up/$token'
      path: '/sign-up/$token'
      fullPath: '/sign-up/$token'
      preLoaderRoute: typeof AuthSignUpTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password/$token': {
      id: '/_auth/forgot-password/$token'
      path: '/forgot-password/$token'
      fullPath: '/forgot-password/$token'
      preLoaderRoute: typeof AuthForgotPasswordTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_protected/_tax/tax/': {
      id: '/_protected/_tax/tax/'
      path: '/tax'
      fullPath: '/tax/'
      preLoaderRoute: typeof ProtectedTaxTaxIndexRouteImport
      parentRoute: typeof ProtectedTaxRoute
    }
    '/_protected/_leasing/leasing/': {
      id: '/_protected/_leasing/leasing/'
      path: '/leasing'
      fullPath: '/leasing/'
      preLoaderRoute: typeof ProtectedLeasingLeasingIndexRouteImport
      parentRoute: typeof ProtectedLeasingRoute
    }
    '/_protected/_import/import/': {
      id: '/_protected/_import/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof ProtectedImportImportIndexRouteImport
      parentRoute: typeof ProtectedImportRoute
    }
    '/_protected/_equipment/equipment/': {
      id: '/_protected/_equipment/equipment/'
      path: '/equipment'
      fullPath: '/equipment/'
      preLoaderRoute: typeof ProtectedEquipmentEquipmentIndexRouteImport
      parentRoute: typeof ProtectedEquipmentRoute
    }
    '/_protected/_dealership/dealership/': {
      id: '/_protected/_dealership/dealership/'
      path: '/dealership'
      fullPath: '/dealership/'
      preLoaderRoute: typeof ProtectedDealershipDealershipIndexRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_tax/tax/create': {
      id: '/_protected/_tax/tax/create'
      path: '/tax/create'
      fullPath: '/tax/create'
      preLoaderRoute: typeof ProtectedTaxTaxCreateRouteImport
      parentRoute: typeof ProtectedTaxRoute
    }
    '/_protected/_leasing/leasing/create': {
      id: '/_protected/_leasing/leasing/create'
      path: '/leasing/create'
      fullPath: '/leasing/create'
      preLoaderRoute: typeof ProtectedLeasingLeasingCreateRouteImport
      parentRoute: typeof ProtectedLeasingRoute
    }
    '/_protected/_leasing/leasing/$id': {
      id: '/_protected/_leasing/leasing/$id'
      path: '/leasing/$id'
      fullPath: '/leasing/$id'
      preLoaderRoute: typeof ProtectedLeasingLeasingIdRouteImport
      parentRoute: typeof ProtectedLeasingRoute
    }
    '/_protected/_import/import/create': {
      id: '/_protected/_import/import/create'
      path: '/import/create'
      fullPath: '/import/create'
      preLoaderRoute: typeof ProtectedImportImportCreateRouteImport
      parentRoute: typeof ProtectedImportRoute
    }
    '/_protected/_import/import/$id': {
      id: '/_protected/_import/import/$id'
      path: '/import/$id'
      fullPath: '/import/$id'
      preLoaderRoute: typeof ProtectedImportImportIdRouteImport
      parentRoute: typeof ProtectedImportRoute
    }
    '/_protected/_dealership/dealership/users': {
      id: '/_protected/_dealership/dealership/users'
      path: '/dealership/users'
      fullPath: '/dealership/users'
      preLoaderRoute: typeof ProtectedDealershipDealershipUsersRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_dealership/dealership/subscription': {
      id: '/_protected/_dealership/dealership/subscription'
      path: '/dealership/subscription'
      fullPath: '/dealership/subscription'
      preLoaderRoute: typeof ProtectedDealershipDealershipSubscriptionRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_dealership/dealership/profile': {
      id: '/_protected/_dealership/dealership/profile'
      path: '/dealership/profile'
      fullPath: '/dealership/profile'
      preLoaderRoute: typeof ProtectedDealershipDealershipProfileRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_dealership/dealership/payment-methods': {
      id: '/_protected/_dealership/dealership/payment-methods'
      path: '/dealership/payment-methods'
      fullPath: '/dealership/payment-methods'
      preLoaderRoute: typeof ProtectedDealershipDealershipPaymentMethodsRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_dealership/dealership/payment-history': {
      id: '/_protected/_dealership/dealership/payment-history'
      path: '/dealership/payment-history'
      fullPath: '/dealership/payment-history'
      preLoaderRoute: typeof ProtectedDealershipDealershipPaymentHistoryRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_dealership/dealership/notifications': {
      id: '/_protected/_dealership/dealership/notifications'
      path: '/dealership/notifications'
      fullPath: '/dealership/notifications'
      preLoaderRoute: typeof ProtectedDealershipDealershipNotificationsRouteImport
      parentRoute: typeof ProtectedDealershipRoute
    }
    '/_protected/_tax/tax/$id/': {
      id: '/_protected/_tax/tax/$id/'
      path: '/tax/$id'
      fullPath: '/tax/$id/'
      preLoaderRoute: typeof ProtectedTaxTaxIdIndexRouteImport
      parentRoute: typeof ProtectedTaxRoute
    }
  }
}

interface AuthRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthForgotPasswordTokenRoute: typeof AuthForgotPasswordTokenRoute
  AuthSignUpTokenRoute: typeof AuthSignUpTokenRoute
  AuthForgotPasswordIndexRoute: typeof AuthForgotPasswordIndexRoute
  AuthSignUpIndexRoute: typeof AuthSignUpIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthForgotPasswordTokenRoute: AuthForgotPasswordTokenRoute,
  AuthSignUpTokenRoute: AuthSignUpTokenRoute,
  AuthForgotPasswordIndexRoute: AuthForgotPasswordIndexRoute,
  AuthSignUpIndexRoute: AuthSignUpIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ProtectedDealershipRouteChildren {
  ProtectedDealershipDealershipNotificationsRoute: typeof ProtectedDealershipDealershipNotificationsRoute
  ProtectedDealershipDealershipPaymentHistoryRoute: typeof ProtectedDealershipDealershipPaymentHistoryRoute
  ProtectedDealershipDealershipPaymentMethodsRoute: typeof ProtectedDealershipDealershipPaymentMethodsRoute
  ProtectedDealershipDealershipProfileRoute: typeof ProtectedDealershipDealershipProfileRoute
  ProtectedDealershipDealershipSubscriptionRoute: typeof ProtectedDealershipDealershipSubscriptionRoute
  ProtectedDealershipDealershipUsersRoute: typeof ProtectedDealershipDealershipUsersRoute
  ProtectedDealershipDealershipIndexRoute: typeof ProtectedDealershipDealershipIndexRoute
}

const ProtectedDealershipRouteChildren: ProtectedDealershipRouteChildren = {
  ProtectedDealershipDealershipNotificationsRoute:
    ProtectedDealershipDealershipNotificationsRoute,
  ProtectedDealershipDealershipPaymentHistoryRoute:
    ProtectedDealershipDealershipPaymentHistoryRoute,
  ProtectedDealershipDealershipPaymentMethodsRoute:
    ProtectedDealershipDealershipPaymentMethodsRoute,
  ProtectedDealershipDealershipProfileRoute:
    ProtectedDealershipDealershipProfileRoute,
  ProtectedDealershipDealershipSubscriptionRoute:
    ProtectedDealershipDealershipSubscriptionRoute,
  ProtectedDealershipDealershipUsersRoute:
    ProtectedDealershipDealershipUsersRoute,
  ProtectedDealershipDealershipIndexRoute:
    ProtectedDealershipDealershipIndexRoute,
}

const ProtectedDealershipRouteWithChildren =
  ProtectedDealershipRoute._addFileChildren(ProtectedDealershipRouteChildren)

interface ProtectedEquipmentRouteChildren {
  ProtectedEquipmentEquipmentIndexRoute: typeof ProtectedEquipmentEquipmentIndexRoute
}

const ProtectedEquipmentRouteChildren: ProtectedEquipmentRouteChildren = {
  ProtectedEquipmentEquipmentIndexRoute: ProtectedEquipmentEquipmentIndexRoute,
}

const ProtectedEquipmentRouteWithChildren =
  ProtectedEquipmentRoute._addFileChildren(ProtectedEquipmentRouteChildren)

interface ProtectedImportRouteChildren {
  ProtectedImportImportIdRoute: typeof ProtectedImportImportIdRoute
  ProtectedImportImportCreateRoute: typeof ProtectedImportImportCreateRoute
  ProtectedImportImportIndexRoute: typeof ProtectedImportImportIndexRoute
}

const ProtectedImportRouteChildren: ProtectedImportRouteChildren = {
  ProtectedImportImportIdRoute: ProtectedImportImportIdRoute,
  ProtectedImportImportCreateRoute: ProtectedImportImportCreateRoute,
  ProtectedImportImportIndexRoute: ProtectedImportImportIndexRoute,
}

const ProtectedImportRouteWithChildren = ProtectedImportRoute._addFileChildren(
  ProtectedImportRouteChildren,
)

interface ProtectedInsightsRouteChildren {
  ProtectedInsightsInsightsRoute: typeof ProtectedInsightsInsightsRoute
}

const ProtectedInsightsRouteChildren: ProtectedInsightsRouteChildren = {
  ProtectedInsightsInsightsRoute: ProtectedInsightsInsightsRoute,
}

const ProtectedInsightsRouteWithChildren =
  ProtectedInsightsRoute._addFileChildren(ProtectedInsightsRouteChildren)

interface ProtectedLeasingRouteChildren {
  ProtectedLeasingLeasingIdRoute: typeof ProtectedLeasingLeasingIdRoute
  ProtectedLeasingLeasingCreateRoute: typeof ProtectedLeasingLeasingCreateRoute
  ProtectedLeasingLeasingIndexRoute: typeof ProtectedLeasingLeasingIndexRoute
}

const ProtectedLeasingRouteChildren: ProtectedLeasingRouteChildren = {
  ProtectedLeasingLeasingIdRoute: ProtectedLeasingLeasingIdRoute,
  ProtectedLeasingLeasingCreateRoute: ProtectedLeasingLeasingCreateRoute,
  ProtectedLeasingLeasingIndexRoute: ProtectedLeasingLeasingIndexRoute,
}

const ProtectedLeasingRouteWithChildren =
  ProtectedLeasingRoute._addFileChildren(ProtectedLeasingRouteChildren)

interface ProtectedTaxRouteChildren {
  ProtectedTaxTaxCreateRoute: typeof ProtectedTaxTaxCreateRoute
  ProtectedTaxTaxIndexRoute: typeof ProtectedTaxTaxIndexRoute
  ProtectedTaxTaxIdIndexRoute: typeof ProtectedTaxTaxIdIndexRoute
}

const ProtectedTaxRouteChildren: ProtectedTaxRouteChildren = {
  ProtectedTaxTaxCreateRoute: ProtectedTaxTaxCreateRoute,
  ProtectedTaxTaxIndexRoute: ProtectedTaxTaxIndexRoute,
  ProtectedTaxTaxIdIndexRoute: ProtectedTaxTaxIdIndexRoute,
}

const ProtectedTaxRouteWithChildren = ProtectedTaxRoute._addFileChildren(
  ProtectedTaxRouteChildren,
)

interface ProtectedRouteChildren {
  ProtectedDealershipRoute: typeof ProtectedDealershipRouteWithChildren
  ProtectedEquipmentRoute: typeof ProtectedEquipmentRouteWithChildren
  ProtectedImportRoute: typeof ProtectedImportRouteWithChildren
  ProtectedInsightsRoute: typeof ProtectedInsightsRouteWithChildren
  ProtectedLeasingRoute: typeof ProtectedLeasingRouteWithChildren
  ProtectedTaxRoute: typeof ProtectedTaxRouteWithChildren
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedPurchaseRoute: typeof ProtectedPurchaseRoute
  ProtectedRedirectToCustomerPortalRoute: typeof ProtectedRedirectToCustomerPortalRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedDealershipRoute: ProtectedDealershipRouteWithChildren,
  ProtectedEquipmentRoute: ProtectedEquipmentRouteWithChildren,
  ProtectedImportRoute: ProtectedImportRouteWithChildren,
  ProtectedInsightsRoute: ProtectedInsightsRouteWithChildren,
  ProtectedLeasingRoute: ProtectedLeasingRouteWithChildren,
  ProtectedTaxRoute: ProtectedTaxRouteWithChildren,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedPurchaseRoute: ProtectedPurchaseRoute,
  ProtectedRedirectToCustomerPortalRoute:
    ProtectedRedirectToCustomerPortalRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  ProtectedRoute: ProtectedRouteWithChildren,
  RedirectRoute: RedirectRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
